import { render } from "./ingresoVideos.vue?vue&type=template&id=53c47df3&scoped=true"
import script from "./ingresoVideos.vue?vue&type=script&lang=js"
export * from "./ingresoVideos.vue?vue&type=script&lang=js"

import "./ingresoVideos.vue?vue&type=style&index=0&id=53c47df3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c47df3"]])

export default __exports__